<div class="m-subheader" style="position: relative;">
  <div class="d-flex align-items-center" style="flex-wrap: wrap;">
    <div class="mr-auto">
      <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
        <li class="m-nav__item m-nav__item--home">
          <a routerLink="/" class="m-nav__link m-nav__link--icon">
            <i class="m-nav__link-icon la la-home"></i>
          </a>
        </li>
        <li class="m-nav__separator">
          -
        </li>
        <li class="m-nav__item">
          <a routerLink="../../" class="m-nav__link">
            <span class="m-nav__link-text">
              {{ 'spend-show.allExpenses' | transloco }}
            </span>
          </a>
        </li>
      </ul>
    </div>

    <div>
    </div>
  </div>

  <div *ngIf="isLoading.invoice" class="m-page-loader m-page-loader--non-block m-page-loader--absolute">
    <div class="m-loader m-loader--brand"></div>
  </div>
</div>

<div class="m-content">
  <!--Begin::Main Portlet-->
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--head-solid-bg">
        <div class="m-portlet__head" style="position: relative;">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">
                {{ 'spend-show.viewingExpenses' | transloco }}
              </h3>
            </div>
          </div>

          <div *ngIf="isLoading.invoice" class="m-page-loader m-page-loader--non-block m-page-loader--absolute">
            <div class="m-loader m-loader--brand"></div>
          </div>
        </div>

        <div class="m-portlet__body">
          <div class="row">
            <div class="col-md-12">

              <div class="form-group m-form__group row">
                <div class="col-lg-2 col-md-3 col-sm-12">
                  {{ 'spend-show.category' | transloco }}:
                </div>

                <div class="col-lg-10 col-md-9 col-sm-12">
                  <div>
                    {{ spend?.spendCategory.title | uiLabel }}
                  </div>
                </div>
              </div>

              <div class="form-group m-form__group row">
                <div class="col-lg-2 col-md-3 col-sm-12">
                  {{ 'spend-show.organization' | transloco }}:
                </div>

                <div class="col-lg-10 col-md-9 col-sm-12">
                  <div>
                    {{ spend?.organization.title | uiLabel }}
                  </div>
                </div>
              </div>

              <div class="form-group m-form__group row">
                <div class="col-lg-2 col-md-3 col-sm-12">
                  {{ 'spend-show.shop' | transloco }}:
                </div>

                <div class="col-lg-10 col-md-9 col-sm-12">
                  <div>
                    {{ spend?.store.title | uiLabel }}
                  </div>
                </div>
              </div>

              <div class="form-group m-form__group row">
                <div class="col-lg-2 col-md-3 col-sm-12">
                  {{ 'spend-show.spent' | transloco }}:
                </div>

                <div class="col-lg-10 col-md-9 col-sm-12">
                  {{ spend?.total }}
                </div>
              </div>

              <div class="form-group m-form__group row">
                <div class="col-lg-2 col-md-3 col-sm-12">
                  {{ 'spend-show.data' | transloco }}:
                </div>

                <div class="col-lg-10 col-md-9 col-sm-12">
                  <span>
                    {{ spend?.date | date:'dd.MM.yy HH:mm' }}
                  </span>
                </div>
              </div>

              <div *ngIf="spend?.paid" class="form-group m-form__group row">
                <div class="col-lg-2 col-md-3 col-sm-12">
                  {{ 'spend-show.paymentDate' | transloco }}:
                </div>

                <div class="col-lg-10 col-md-9 col-sm-12">
                  <div>
                    {{ spend?.paid | date:'dd.MM.yy HH:mm' }}
                  </div>
                </div>
              </div>

              <div class="form-group m-form__group row">
                <label class="col-lg-2 col-md-3 col-sm-12">
                  {{ 'spend-show.note' | transloco }}:
                </label>
                <div *ngIf="isPaid" class="col-lg-10 col-md-9 col-sm-12">
                  {{ spend?.note }}
                </div>
                <div *ngIf="!isPaid" class="col-lg-10 col-md-9 col-sm-12">
                  <textarea type="text" cols="50" [(ngModel)]="note"></textarea>
                </div>
              </div>
          </div>
        </div>
          <div class="m-form__actions m-form__actions--paddingless-sides">
            <div class="row">
              <div class="col-12 text-right">
                <button *ngIf="!isPaid" type="submit" (click)="onSubmitForm()"
                        class="btn btn-success m--margin-right-10">
                  {{ 'spend-show.btn.paid' | transloco }}
                </button>

                <button *ngIf="isPaid && isDateEqual" (click)="onSubmitForm()" type="submit"
                        class="btn btn-danger m--margin-right-10">
                  {{ 'spend-show.btn.cancelPaid' | transloco }}
                </button>

                <button type="button" (click)="cancel()" class="btn btn-secondary m--margin-right-10">
                  {{ 'btn.cancel' | transloco }}
                </button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  <!--End::Main Portlet-->
</div>
